// Ordered day-by-day videos for the 21-Day Self-Care Challenge.
// Each day may include optional/bonus `extras` (a video or an external resource link)
// that appear alongside that day's main video but are not required viewing, and/or a
// `note` - a milestone callout rendered as a full-width banner right after that day's card.
export const SELF_CARE_CHALLENGE_VIDEOS = [
   {
    id: "day-1",
    day: 1,
    title: "Your Wellness Vision",
    durationLabel: "4:43",
    vimeoUrl: "https://vimeo.com/317695481/42f79b0cc9?share=copy&fl=sv&fe=ci",
  },
  {
    id: "day-2",
    day: 2,
    title: "Mindfulness, SEL, Self-Care and YOU",
    durationLabel: "5:07",
    vimeoUrl: "https://vimeo.com/318170077/f94ba0ebc5?share=copy&fl=sv&fe=ci",
  },
  {
    id: "day-3",
    day: 3,
    title: "1-2-3 Wellness: Creating Mindful Habits",
    durationLabel: "8:14",
    vimeoUrl: "https://vimeo.com/317699499/0c0727bd0a?share=copy&fl=sv&fe=ci",
  },
  {
    id: "day-4",
    day: 4,
    title: "Your Wellness Library",
    durationLabel: "5:08",
    vimeoUrl: "https://vimeo.com/317703694/ce9fecf0fc?share=copy&fl=sv&fe=ci",
  },
  {
    id: "day-5",
    day: 5,
    title: "Your Purpose as a Guide",
    durationLabel: "4:22",
    vimeoUrl: "https://vimeo.com/317705366/2e516fca0a?share=copy&fl=sv&fe=ci",
  },
  {
    id: "day-6",
    day: 6,
    title: "Your Thoughts are Powerful",
    durationLabel: "4:58",
    vimeoUrl: "https://vimeo.com/317706830/b660d0ea8b?share=copy&fl=sv&fe=ci",
  },
  {
    id: "day-7",
    day: 7,
    title: "Your Best Self",
    durationLabel: "3:42",
    vimeoUrl: "https://vimeo.com/317708636/2f1a497538?share=copy&fl=sv&fe=ci",
  },
  {
    id: "day-8",
    day: 8,
    title: "Healthy Thoughts",
    durationLabel: "2:43",
    vimeoUrl: "https://vimeo.com/317709939/6f92e80fb0?share=copy&fl=sv&fe=ci",
  },
  {
    id: "day-9",
    day: 9,
    title: "Mindful Now",
    durationLabel: "4:15",
    vimeoUrl: "https://vimeo.com/317711137/5bd297c891?share=copy&fl=sv&fe=ci",
    extras: [
      {
        kind: "video",
        id: "day-9-optional-meditation",
        label: "Optional Guided Meditation",
        durationLabel: null,
        vimeoUrl: "https://vimeo.com/318169002/6c6feaeb1a?share=copy&fl=sv&fe=ci",
      },
    ],
  },
  {
    id: "day-10",
    day: 10,
    title: "Processing Emotions in a Healthy Way",
    durationLabel: "4:14",
    vimeoUrl: "https://vimeo.com/317712551/b74e273118?share=copy&fl=sv&fe=ci",
  },
  {
    id: "day-11",
    day: 11,
    title: "Emotions and the Brain",
    durationLabel: "2:55",
    vimeoUrl: "https://vimeo.com/317715246/f7c1df5f7a?share=copy&fl=sv&fe=ci",
  },
  {
    id: "day-12",
    day: 12,
    title: "Self-Compassion",
    durationLabel: "3:18",
    vimeoUrl: "https://vimeo.com/317732979/982a343ca1?share=copy&fl=sv&fe=ci",
  },
  {
    id: "day-13",
    day: 13,
    title: "Appreciation",
    durationLabel: "3:04",
    vimeoUrl: "https://vimeo.com/317725799/2ea1f4f24f?share=copy&fl=sv&fe=ci",
  },
  {
    id: "day-14",
    day: 14,
    title: "Reflect and Breath",
    durationLabel: "2:33",
    vimeoUrl: "https://vimeo.com/317717214/50ebe8ab00?share=copy&fl=sv&fe=ci",
    extras: [
      {
        kind: "video",
        id: "day-14-optional-meditation",
        label: "Optional Guided Meditation",
        durationLabel: null,
        vimeoUrl: "https://vimeo.com/318061087/0f282249cc?share=copy&fl=sv&fe=ci",
      },
    ],
  },
  {
    id: "day-15",
    day: 15,
    title: "Stress Mindsets: Creating Wellbeing",
    durationLabel: "2:57",
    vimeoUrl: "https://vimeo.com/317718004/1ba38e2ed6?share=copy&fl=sv&fe=ci",
  },
  {
    id: "day-16",
    day: 16,
    title: "Simple Movements",
    durationLabel: "5:36",
    vimeoUrl: "https://vimeo.com/317718841/651fddf547?share=copy&fl=sv&fe=ci",
  },
  {
    id: "day-17",
    day: 17,
    title: "Your Self-Care Plan",
    durationLabel: "3:09",
    vimeoUrl: "https://vimeo.com/317720467/ce91d7d412?share=copy&fl=sv&fe=ci",
    note: {
      heading: "Nice work completing your Self-Care Plan!",
      body: [
        "Awesome job creating your personalized self-care plan! If you look in your 1-2-3 Wellness workbook, you’ll notice that all of your self-care insights have populated together for one cohesive, personalized self-care plan. You can draw upon and revisit your plan to support your well-being the rest of your life :)",
      ],
      subheading:
        "Also, more good news! 1-2-3 Wellness offers INCREDIBLY powerful tools which empower students to create daily wellness habits with benefits for academics, behavior, attendance and more!",
      list: [
        {
          label: "A.",
          parts: [
            "You and your students are invited to use the 1-2-3 Wellness app 2x a day (once in the morning and once in the afternoon).",
          ],
        },
        {
          label: "B.",
          parts: [
            "Use the data from your app to learn what helps you and your students to successfully navigate different emotions",
          ],
        },
        {
          label: "C.",
          parts: [
            "The 1-2-3 Wellness school ",
            {
              text: "resources library",
              url: "https://drive.google.com/drive/folders/1HpXM89eDyK5LIIW8MgumAzeMyadBzg-D?usp=sharing",
            },
            " includes lesson plans, e-workbooks and more to guide you and your students. Please note that in your resources library, you will find posters. Please print one and hang it on your wall.",
          ],
        },
      ],
      footer:
        "Videos 18-20 below are a bit outdated since the app and lesson plans are designed to guide your success with students. So please feel free to watch videos 18-20 for ideas OR jump to video 21 if you’d like!",
    },
  },
  {
    id: "day-18",
    day: 18,
    title: "Teaching 1-2-3 Wellness to Your Kids/Students",
    durationLabel: "3:11",
    vimeoUrl: "https://vimeo.com/317721435/127ce4232d?share=copy&fl=sv&fe=ci",
  },
  {
    id: "day-19",
    day: 19,
    title: "Laying the Foundation for Student Success",
    durationLabel: "4:11",
    vimeoUrl: "https://vimeo.com/317722476/fe0c9c3c7c?share=copy&fl=sv&fe=ci",
  },
  {
    id: "day-20",
    day: 20,
    title: "AAA Healthy Habit: Anyone. Anywhere. Anytime.",
    durationLabel: "4:32",
    vimeoUrl: "https://vimeo.com/317723717/85270d181e?share=copy&fl=sv&fe=ci",
  },
  {
    id: "day-21",
    day: 21,
    title: "Celebration and Conclusion",
    durationLabel: "3:00",
    vimeoUrl: "https://vimeo.com/317725086/491825d36d?share=copy&fl=sv&fe=ci",
    extras: [
      {
        kind: "video",
        id: "day-21-bonus-bloopers",
        label: "Bonus: A Few Bloopers: Laughter is Key",
        durationLabel: null,
        vimeoUrl: "https://vimeo.com/318055170/d1fbce93f5?share=copy&fl=sv&fe=ci",
      },
    ],
  },
];
